import i18n from '@/lang/vue-18n';

export default class UserRoleType {
    static readonly STUDENT = new UserRoleType('student', 'sky');
    static readonly JUDGE = new UserRoleType('judge', 'green');
    static readonly GARANT = new UserRoleType('garant', 'orange');
    static readonly VSK = new UserRoleType('vsk', 'violet');
    static readonly ADMIN = new UserRoleType('admin', 'red');
    static readonly ROUND_MANAGER = new UserRoleType('roundmanager', 'cyan');
    static readonly NONE = new UserRoleType('none', 'gray');

    public static readonly VALUES = [UserRoleType.STUDENT, UserRoleType.JUDGE, UserRoleType.GARANT, UserRoleType.VSK, UserRoleType.ROUND_MANAGER, UserRoleType.ADMIN, UserRoleType.NONE];

    static parse(slug: string): UserRoleType {
        return UserRoleType.VALUES.find(s => s.slug == slug) || UserRoleType.NONE;
    }

    public style: string[]

    private constructor(public readonly slug: string, public readonly color: string) {
        this.style = [`bg-${color}-100`, `text-${color}-800`];
    }

    public translateName(): string {
        return i18n.global.t(`user_role.${this.slug}`)
    }
}
